var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 76,
    viewBox: "0 0 141 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.689 72C140.689 59.7124 137.455 47.6413 131.311 37C125.167 26.3586 116.331 17.522 105.689 11.3782L70.6895 72H140.689Z",
    fill: "#03DD6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3105 11.3782C24.6692 17.522 15.8325 26.3586 9.68877 37C3.54498 47.6413 0.310546 59.7124 0.310547 72L70.3105 72L35.3105 11.3782Z",
    fill: "#EEEEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.177 11.8782L106.677 11.0122L105.811 10.5122C95.0172 4.28064 82.7737 0.999999 70.3105 1C57.8474 1 45.6039 4.28065 34.8105 10.5122L33.9445 11.0122L34.4445 11.8782L69.4445 72.5L70.3106 74L71.1766 72.5L106.177 11.8782Z",
    fill: "#EEEEEE",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.689 72C106.689 62.4522 102.897 53.2955 96.1453 46.5442C89.394 39.7928 80.2373 36 70.6895 36C61.1417 36 51.9849 39.7928 45.2336 46.5442C38.4823 53.2955 34.6895 62.4522 34.6895 72L106.689 72Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPie);
export default __webpack_public_path__ + "static/media/greenPie.e43d6634bd7ff45150a4404c6cba9c1e.svg";
export { ForwardRef as ReactComponent };